import React from 'react';
import styled from 'styled-components';
import MarketoForm from 'epic-node-marketo/src/client/MarketoForm';
import {ButtonWrap} from 'epic-node-marketo/src/client/MarketoForm.styles';
export interface FieldGroupProps {
    id: string;
    label: string;
    type: string;
    fields: {id: string}[];
}

interface GenericMap {
    [key: string]: string | boolean | number | undefined;
}

export interface MarketoFormProps {
    fieldGroups?: FieldGroupProps;
    initalValues?: GenericMap;
    account?: GenericMap;
    preSubmitMutateFn?: (fieldGroup: FieldGroupProps, values: GenericMap) => void;
    fieldAdjustments?: any;
    formId: string;
    messages?: GenericMap;
    loadingImg?: string;
    formType?: string;
    postSubmitFn?: (response: GenericMap) => void;
    form?: any;
    autoComplete?: string;
    customEndpointUrl?: string;
}

export const UEMarketoFormWrapper = styled.div`
    ${ButtonWrap} {
        button.mkt-btn {
            border-radius: 0px;
            padding: 8px 16px;
            margin: 16px;
            max-width: 300px;
            text-align: center;
            font-size: 1.1em;
            text-transform: uppercase;
            letter-spacing: 1px;
            transition: background 0.2s ease-in-out, border 0.2s ease-in-out;
            font-family: ${(p) => p.theme.ue.fonts.brutal.regular};
            border: 2px solid #fff;
            display: inline-block;
            min-height: 48px;
        }

        button.mkt-btn.mkt-pri-btn {
            background-color: ${(p) => p.theme.ue.colors.buttons.primary.background.default};
            border-color: ${(p) => p.theme.ue.colors.buttons.primary.border.default};
            color: ${(p) => p.theme.ue.colors.buttons.primary.text.default};
            &:hover,
            &:focus,
            &:active {
                &:not([disabled]) {
                    background-color: ${(p) => p.theme.ue.colors.buttons.primary.background.hover};
                    border-color: ${(p) => p.theme.ue.colors.buttons.primary.border.hover};
                    color: ${(p) => p.theme.ue.colors.buttons.primary.text.hover};
                }
            }
            &[disabled] {
                color: ${(p) => p.theme.ue.colors.buttons.primary.text.disabled};
                border-color: ${(p) => p.theme.ue.colors.buttons.primary.border.disabled};
                background-color: ${(p) => p.theme.ue.colors.buttons.primary.background.disabled};
            }
        }

        button.mkt-btn.mkt-sec-btn {
            background-color: transparent;
            border-color: white;
            color: white;

            &:hover,
            &:active {
                &:not([disabled]) {
                    background-color: white;
                    border-color: white;
                    color: black;
                }
            }

            &[disabled] {
                background-color: ${(p) => p.theme.ue.colors.buttons.tertiary.background.disabled};
                border-color: ${(p) => p.theme.ue.colors.buttons.tertiary.border.disabled};
                color: ${(p) => p.theme.ue.colors.buttons.tertiary.text.disabled};
            }
        }
    }

    .successWrap h3 {
        font-size: 1.7em;
    }

    .checkbox {
        text-align: left;
    }

    label {
        max-width: calc(100% - 32px);
    }
    textarea {
        min-height: 50px;
    }
`;

export const UEMarketoForm = (props: MarketoFormProps): JSX.Element => {
    return (
        <UEMarketoFormWrapper>
            <MarketoForm autoComplete="off" {...props} />
        </UEMarketoFormWrapper>
    );
};
